import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Accordion } from "@circle-react-uikit/Accordion";
import type { ButtonType, ButtonVariant } from "../index";
import { Inputs } from "./Inputs";
import { Selector } from "./Selector";

interface BorderRadiusSelectorProps {
  buttonType: ButtonType;
  buttonVariant: ButtonVariant;
}

export type ButtonRadiusSelectorType = "all" | "individual";

export const BorderRadiusSelector = ({
  buttonType,
  buttonVariant,
}: BorderRadiusSelectorProps) => {
  const [selectedRadius, setSelectedRadius] =
    useState<ButtonRadiusSelectorType>("all");

  return (
    <div className="px-6 pt-5">
      <Accordion defaultOpen>
        <Accordion.Item
          title={t(
            "builder_ui.theme_configuration.site_styles.button_styles.corners",
          )}
        >
          <div className="flex flex-col gap-2 px-1 pb-5">
            <div className="flex w-full items-center justify-between">
              <Typography.LabelSm>
                <span className="text-dark text-[15px] font-semibold">
                  {t(
                    "builder_ui.theme_configuration.site_styles.button_styles.corner_radius",
                  )}
                </span>
              </Typography.LabelSm>
              <Selector
                selectedRadius={selectedRadius}
                setSelectedRadius={setSelectedRadius}
              />
            </div>
            <Inputs
              buttonType={buttonType}
              buttonVariant={buttonVariant}
              selectedRadius={selectedRadius}
            />
          </div>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
